import { useEffect } from "react";

export default function useScrollHighlight() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Observer 1: Reveal cards as they scroll into view
    const revealCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("hk-card-in-view");
        }
      });
    };

    // Observer 2: Highlight card in viewport focus center (mobile/tablet)
    const focalCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("hk-card-focused");
        } else {
          entry.target.classList.remove("hk-card-focused");
        }
      });
    };

    const revealObserver = new IntersectionObserver(revealCallback, {
      threshold: 0.12,
      rootMargin: "0px 0px -30px 0px",
    });

    const focalObserver = new IntersectionObserver(focalCallback, {
      threshold: 0.45,
      rootMargin: "-15% 0px -15% 0px",
    });

    const selector =
      ".service-card, .room-card, .attraction-card, .hk-modern-review-card, .quick-fact-card, .hk-polaroid-frame";

    const updateObservers = () => {
      const cards = document.querySelectorAll(selector);
      cards.forEach((card, index) => {
        card.classList.add("hk-reveal-card");
        card.style.setProperty("--hk-stagger-delay", `${(index % 3) * 110}ms`);
        revealObserver.observe(card);
        focalObserver.observe(card);
      });
    };

    updateObservers();

    // Re-observe after a short delay for dynamically rendered items
    const timer = setTimeout(updateObservers, 500);

    return () => {
      clearTimeout(timer);
      const cards = document.querySelectorAll(selector);
      cards.forEach((card) => {
        revealObserver.unobserve(card);
        focalObserver.unobserve(card);
      });
    };
  }, []);
}
